import React from "react";
import PropTypes from "prop-types";
import './folder.css';
import {FaRegFolder} from "react-icons/fa";

const Folder = ({ name, currentFolderURL, setCurrentFolderURL, setCurrentFolderName }) => {

 var pathLink = "?path="+ currentFolderURL.replace("/sites/PublicWebsiteDocuments", "").replace("/sites/CloudRecords", "") + "/"+ name
 var title = "Navigate to " + name + "Folder"
    return (
      <tr>
        <td>
         <a href={pathLink} data-itemtype="Folder" title={title}>
               <FaRegFolder /> {name}
     </a>
        </td>

      </tr>
      
    );
  }



Folder.propTypes = {
    name: PropTypes.string.isRequired,
    currentFolderURL: PropTypes.string,
    setCurrentFolderURL: PropTypes.func
};
 

export default Folder;